import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetStoreDepositDetailsQuery } from '../slices/storeDepositsApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import StoreDepositCarousel from '../components/StoreDepositCarousel';

const StoreDepositScreen = () => {
  const { id: storeDepositId } = useParams();
  const { data: storeDeposit, isLoading, error } = useGetStoreDepositDetailsQuery(storeDepositId);

  const renderStoreDepositDetails = () => (
    <>
      <Meta title={storeDeposit.date} description={storeDeposit.account} />
      <Row>
        <Col md={6}>
          {/* Display storeDeposit images using StoreDepositCarousel */}
          {storeDeposit.images && storeDeposit.images.length > 0 ? (
            <StoreDepositCarousel images={storeDeposit.images} />
          ) : (
            <Message variant="info">No images available for this storeDeposit</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{storeDeposit.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {storeDeposit.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {storeDeposit.amount}</ListGroup.Item>
            <ListGroup.Item>
              Category: {storeDeposit.category}
            </ListGroup.Item>
            <ListGroup.Item>Notes:{storeDeposit.notes}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{storeDeposit.amount}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {storeDeposit.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="storeDeposit-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {storeDeposit.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderStoreDepositDetails()
      )}
    </>
  );
};

export default StoreDepositScreen;